module.exports = __webpack_public_path__ + "static/vine_blight-b629441e3b6ac09cf9d6afec61af1319.jpg";